import * as React from 'react';

import { ScrollProgressBarContainer } from './styled';

export const ScrollProgressBar = () => {
  const [scrollPosition, setScrollPosition] = React.useState(0);

  React.useEffect(() => {
    document.addEventListener('scroll', () => {
      calculateScrollDistance();
    });

    return () => {
      document.removeEventListener('scroll', () => {
        calculateScrollDistance();
      });
    };
  }, []);

  const getDocHeight = () => {
    return Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight,
    );
  };

  const calculateScrollDistance = () => {
    const scrollTop = window.pageYOffset;
    const winHeight = window.innerHeight;
    const docHeight = getDocHeight();

    const totalDocScrollLength = docHeight - winHeight;
    const newScrollPosition = Math.floor(
      (scrollTop / totalDocScrollLength) * 100,
    );

    setScrollPosition(newScrollPosition);
  };

  return <ScrollProgressBarContainer $scrolled={scrollPosition} />;
};
